export const color = (color) => ({ theme }) => theme.colors[color];
export const u = (multiplier = 1) => ({ theme }) =>
  `${theme.spacing.u * multiplier}px`;
